import { api } from '@services';

const getContentLength = async (customFieldId: string): Promise<number> => {
  const { data: length } = await api.get(
    `/customFields/${customFieldId}/content/length`,
  );
  return length;
};

export { getContentLength };
